import { DS_BREAKPOINT, DS_SHAPE_SPACING } from '@calm/evexia-design-tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { GlobalLayoutProps } from '.';

export const GlobalLayoutContainer = styled.div`
    display: grid;

    ${({ rowGap }: GlobalLayoutProps) => css`
        row-gap: ${rowGap || DS_SHAPE_SPACING.SECTION}px;
    `}

    // Ultra Compact layout
    @media screen and (max-width: ${DS_BREAKPOINT.SMALL}px) {
        grid-template-columns: 1fr;
        margin: 0 ${DS_SHAPE_SPACING.SIDE_SMALL}px;
        column-gap: ${DS_SHAPE_SPACING.SIDE_SMALL}px;
    }
    // Compact layout
    @media screen and (min-width: ${DS_BREAKPOINT.SMALL}px) and (max-width: ${DS_BREAKPOINT.MEDIUM}px) {
        grid-template-columns: 1fr 1fr;
        column-gap: ${DS_SHAPE_SPACING.SIDE_SMALL}px;
        margin: 0 ${DS_SHAPE_SPACING.SIDE_SMALL}px;
    }
    // Medium layout
    @media screen and (min-width: ${DS_BREAKPOINT.MEDIUM}px) and (max-width: ${DS_BREAKPOINT.LARGE}px) {
        grid-template-columns: repeat(6, 1fr);
        column-gap: ${DS_SHAPE_SPACING.SIDE_MEDIUM}px;
        margin: 0 ${DS_SHAPE_SPACING.SIDE_MEDIUM}px;
    }
    // Expanded layout
    @media screen and (min-width: ${DS_BREAKPOINT.LARGE}px) {
        grid-template-columns: repeat(12, 1fr);
        column-gap: ${DS_SHAPE_SPACING.SIDE_MEDIUM}px;
        margin: 0 ${DS_SHAPE_SPACING.SIDE_LARGE}px;
    }
`;
